import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConnectivityTestComponent } from './components/connectivity-test/connectivity-test.component';
import { AuthGuard } from './gaurd/auth.guard';
import { ForgotPassComponent } from './pages/forgot-pass/forgot-pass.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
// import { ReportComponent } from './pages/report/report.component';
import { ReportNewComponent } from './pages/report-new/report-new.component';
import { Report2Component } from './pages/report2/report2.component';
import { ValidationComponent } from './pages/validation/validation.component';
import { VinInformationComponent } from './pages/vin-information/vin-information.component';

import { ScrollService } from '../_services/scroll.service';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPassComponent
  },
  {
    path: 'vin-information',
    canActivate: [AuthGuard],
    component: VinInformationComponent
  },
  {
    path: 'connectivity-test',
    canActivate: [AuthGuard],
    component: ConnectivityTestComponent
  },
  {
    path: 'validation',
    canActivate: [AuthGuard],
    component: ValidationComponent
  },
  {
    //Importing the children module to load the components under Vam Module
    path: 'vam',
    loadChildren: () => import('./pages/vam/vam.module').then((m) => m.VamModule)
    // canActivate: [AuthGuard],
  },
  {
    path: 'home-information/access_token/:token/vehicleID/:vehicleId',
    redirectTo: '/information'
  },
  {
    path: 'report',
    component: ReportNewComponent
    // canActivate: [AuthGuard, RatingBodyType],
  },
  // {
  //   path: 'report-new',
  //   component: ReportNewComponent
  //   // canActivate: [AuthGuard, RatingBodyType],
  // },
  {
    path: 'report2',
    component: Report2Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [ScrollService],
  exports: [RouterModule]
})
export class AppRoutingModule {}
